import styles from './CapabilitiesSection.module.css'

type RoadCard = {
  icon: string
  status: 'live' | 'soon' | 'later'
  statusLabel: string
  when: string
  sport: string
  desc: string
  active?: boolean
}

const ROADMAP: RoadCard[] = [
  {
    icon: '⚽',
    status: 'live',
    statusLabel: 'AO VIVO',
    when: 'desde MAR 2026',
    sport: 'Futebol',
    desc: 'Brasileirão Série A, Premier League, La Liga, Copa de Seleções 2026. Tempo real.',
    active: true,
  },
  {
    icon: '🎮',
    status: 'soon',
    statusLabel: 'EM BREVE',
    when: 'SET 2026',
    sport: 'CS2 · Esports',
    desc: 'Fantasy de times pro: Major, ESL, BLAST. KDA, ADR, multikills viram pontos.',
  },
  {
    icon: '🏀',
    status: 'soon',
    statusLabel: 'EM BREVE',
    when: 'OUT 2026',
    sport: 'Basquete',
    desc: 'NBB + NBA. Cinco titulares, banco, double-double com peso. Mesmas regras de matchday ao vivo.',
  },
  {
    icon: '🏟️',
    status: 'later',
    statusLabel: '2027',
    when: 'VEM AÍ',
    sport: 'League · Valorant · F1',
    desc: 'Pediu? Vota no roadmap. A engine é a mesma — qualquer esporte com stats e relógio funciona.',
  },
]

const STATUS_CLASS: Record<RoadCard['status'], string> = {
  live:  'statusLive',
  soon:  'statusSoon',
  later: 'statusLater',
}

export function CapabilitiesSection() {
  return (
    <section className={styles.section} id="esportes" style={{ paddingTop: 0 }}>
      <div className={styles.sectionHead}>
        <div>
          <div className={styles.num}>01 / ESPORTES</div>
          <h2 className={styles.heading}>
            Começa com bola.<br />
            Não para nela.
          </h2>
        </div>
        <div className={styles.headRight}>
          Fantyx começa onde a maioria mora: futebol. Esports e mais esportes entram na temporada 2027.
        </div>
      </div>

      <div className={styles.roadmap}>
        {ROADMAP.map((card) => (
          <div
            key={card.sport}
            className={`${styles.roadCard} ${card.active ? styles.roadCardActive : ''}`}
          >
            <div className={styles.iconBlock}>{card.icon}</div>
            <span className={`${styles.status} ${styles[STATUS_CLASS[card.status]]}`}>
              {card.statusLabel}
            </span>
            <div className={styles.when}>{card.when}</div>
            <div className={styles.sportTag}>{card.sport}</div>
            <p className={styles.desc}>{card.desc}</p>
          </div>
        ))}
      </div>
    </section>
  )
}
